module.exports = __webpack_public_path__ + "static/img/myszok.48023f57.webp";